// extracted by mini-css-extract-plugin
module.exports = {"fadeInSection":"FadeIn-module--fade-in-section--2LqUk","isVisible":"FadeIn-module--is-visible--3kpp2"};